import { fetchMissingRowData } from './fetchMissingRowData';

export const getResolvedRowsToUse = async (
  dataset: any,
  rowsToUse: any[],
  selectedVirtualRows: number,
  fetchDatasetData: () => Promise<any[]>,
  deselectedRowIds: Set<string>
) => {
  let resolvedRowsToUse: any[] = [...rowsToUse];
  const hasToFetchMissinRows = selectedVirtualRows > 0;

  if (hasToFetchMissinRows) {
    const missingData = await fetchMissingRowData(
      dataset,
      rowsToUse,
      fetchDatasetData,
      deselectedRowIds
    );
    resolvedRowsToUse = [...missingData];
  }

  return resolvedRowsToUse;
};
